/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { useRef, useCallback } from 'react';
import { NativeSyntheticEvent, NativeScrollEvent } from 'react-native';

export const useScrollDirection = (
  onScrollDirectionChange?: (direction: 'up' | 'down') => void,
) => {
  const lastScrollY = useRef(0);

  const handleScroll = useCallback(
    (event: NativeSyntheticEvent<NativeScrollEvent>) => {
      const currentY = event.nativeEvent.contentOffset.y;
      // Ignore negative scroll (bounce effect at top)
      if (currentY < 0) return;

      const diff = currentY - lastScrollY.current;
      // Only trigger if moved significantly to avoid jitter
      if (Math.abs(diff) > 3) {
        const direction = diff > 0 ? 'up' : 'down';
        onScrollDirectionChange?.(direction);
        lastScrollY.current = currentY;
      }
    },
    [onScrollDirectionChange],
  );

  return handleScroll;
};
